function FooterComponent() {
    return (
        <footer className="bg-gray-800 text-white py-4 mb-3 pt-3 w-full">
            <div className="container mx-auto text-center">
                <span>&copy; 2025 princesingh.co.in</span>
            </div>
        </footer>
    );
}

export default FooterComponent;
